module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/steven-2de8062db052c684f62093d8938cc1c5.png";